import { registerSprite } from "./registry";

const C = {
  ember:   "#d36b3c",
  hot:     "#e6e2cf",
  plasma:  "#5f8db6",
  plasmaH: "#d6e8f4",
  warn:    "#9b2d2d",
  carbon:  "#2c2c2c",
  steel:   "#3a3a3a",
  steelH:  "#5a5a5a",
};

function svg(w: number, h: number, body: string): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}" shape-rendering="crispEdges">${body}</svg>`;
}

const kineticRound = svg(
  8, 8,
  `<circle cx="4" cy="4" r="4" fill="${C.steel}" shape-rendering="geometricPrecision"/>`,
);

registerSprite("round_small", { width: 8, height: 8, svg: kineticRound });
registerSprite("shell_med",   { width: 8, height: 8, svg: kineticRound });
registerSprite("slug_rail",   { width: 8, height: 8, svg: kineticRound });

registerSprite("missile_basic", {
  width: 5, height: 3,
  svg: svg(5, 3, `
    <rect x="0" y="0" width="4" height="3" fill="${C.warn}"/>
    <rect x="4" y="1" width="1" height="1" fill="${C.ember}"/>
    <rect x="0" y="1" width="1" height="1" fill="${C.carbon}"/>
  `),
});

// Mining beam visual is generated procedurally in tiles.wgsl (see
// FLAG_MINING_BEAM in beam-tiles.ts). This entry only exists so the
// atlas lookup keyed on `weapon.beamSprite = "mining_beam"` still
// resolves to *something*; the texel itself is never sampled.
registerSprite("mining_beam", {
  width: 1, height: 1,
  svg: svg(1, 1, `<rect x="0" y="0" width="1" height="1" fill="#000" fill-opacity="0"/>`),
});

registerSprite("dock_line_red", {
  width: 4, height: 4,
  svg: svg(4, 4, `
    <rect x="0" y="1" width="4" height="2" fill="#9b2d2d" fill-opacity="0.55"/>
    <rect x="0" y="2" width="4" height="1" fill="#e34a4a" fill-opacity="0.95"/>
    <rect x="0" y="1" width="4" height="1" fill="#ffd6d0" fill-opacity="0.85"/>
  `),
});

registerSprite("dock_line_green", {
  width: 4, height: 4,
  svg: svg(4, 4, `
    <rect x="0" y="1" width="4" height="2" fill="#2d7a3f" fill-opacity="0.55"/>
    <rect x="0" y="2" width="4" height="1" fill="#48c267" fill-opacity="0.95"/>
    <rect x="0" y="1" width="4" height="1" fill="#d6f5dd" fill-opacity="0.85"/>
  `),
});

registerSprite("dock_line_orange", {
  width: 4, height: 4,
  svg: svg(4, 4, `
    <rect x="0" y="1" width="4" height="2" fill="#a85a18" fill-opacity="0.55"/>
    <rect x="0" y="2" width="4" height="1" fill="#e69234" fill-opacity="0.95"/>
    <rect x="0" y="1" width="4" height="1" fill="#ffe4c0" fill-opacity="0.85"/>
  `),
});